import { EnvService } from '@aipb/gulliver/env/util';
import { inject, Injectable } from '@angular/core';
import { CookieConsentHandler } from './cookie-consent.handler';
import { DocumentTitleHandler } from './document-title.handler';
import { FrameHandler } from './frame.handler';
import { LogInfoHandler } from './log-info.handler';
import { PlausibleHandler } from './plausible.handler';
import { ScriptHandler } from './script.handler';
import { SentryBreadcrumbHandler } from './sentry-breadcrumb.handler';
import { SetupHandler } from './setup.handler';
import { ThemeHandler } from './theme.handler';
import { TranslationHandler } from './translation.handler';
import { FooterReferenceHandler } from './footer-reference.handler';

@Injectable({
  providedIn: 'root'
})
export class SetupHandlerManager {
  private env = inject(EnvService);

  private _handlers: SetupHandler[] = [
    inject(ThemeHandler),
    inject(ScriptHandler),
    inject(PlausibleHandler),
    inject(LogInfoHandler),
    inject(DocumentTitleHandler),
    inject(FrameHandler),
    inject(SentryBreadcrumbHandler),
    inject(TranslationHandler),
    inject(CookieConsentHandler),
    inject(FooterReferenceHandler)
  ];

  public init() {
    this._handlers.forEach((handler) => {
      handler.init(this.env.raw);
    });
  }
}
